import * as yup from 'yup'
import { MAXIMUM_IMAGE_SIZE } from '@/shared/utils/imageUploadUtility'

const createChildrenSchema = yup.object().shape({
    firstName: yup
        .string()
        .min(2, 'First Name must be at least 2 characters')
        .required('First Name is required'),
    lastName: yup
        .string()
        .min(2, 'Last Name must be at least 2 characters')
        .required('Last Name is required'),
    dateOfBirth: yup.date().required('Date of Birth is required'),
    picture: yup
        .mixed()
        .required()
        .test('noImage', 'Image is required', (value: any) => {
            return value && value[0]?.size
        })
        .test('fileSize', 'The file is too large', (value: any) => {
            return value && value[0].size <= MAXIMUM_IMAGE_SIZE
        }),
    gender: yup.string().required('Gender is required'),
    allergies: yup.string().required('Allergies is required'),
    bloodGroup: yup.string()
})

export default createChildrenSchema
